import * as yup from 'yup';

export const schema = yup.object().shape({
  firstName: yup.string().required('The first name field is required.'),
  lastName: yup.string().required('The last name field is required.'),
  company: yup.string().required('The company field is required.'),
  title: yup.string(),
  phone: yup.string()
});
